/**
 * Utility functions around the Web Crypto APIs
 */

/**
 * Compute a signature for non-sensitive data using the given secret.
 * This uses the HMAC algorithm with SHA-1 hashing.
 *
 * **NOTE**: This is insecure and should
 * not be used for sensitive data.
 */
export const compute_insecure_signature = async (
  data: Record<string, unknown>,
  secret: string
): Promise<ArrayBuffer | null> => {
  const isWindowValid = typeof window !== "undefined" && Boolean(window);
  const isCryptoValid = isWindowValid && typeof window.crypto !== "undefined";
  const isTextEncoderValid =
    isWindowValid && typeof window.TextEncoder !== "undefined";

  if (isCryptoValid && isTextEncoderValid) {
    const encoder = new TextEncoder();

    const key = await window.crypto.subtle.importKey(
      "raw",
      encoder.encode(secret),
      {
        name: "HMAC",
        hash: "SHA-1",
      },
      false,
      ["sign"]
    );
    const encoded = encoder.encode(JSON.stringify(data));
    return window.crypto.subtle.sign(
      { name: "HMAC", hash: "SHA-1" },
      key,
      encoded
    );
  }

  return null;
};
